import { Star } from 'lucide-react';

export function StarRating({ rating, onRatingChange, readonly = false, size = 'md' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };
  
  const stars = [1, 2, 3, 4, 5];
  
  return (
    <div className="flex gap-1">
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => !readonly && onRatingChange?.(star)}
          disabled={readonly}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'} transition-transform`}
        >
          <Star
            className={`${sizeClasses[size]} ${
              star <= rating
                ? 'fill-yellow-400 text-yellow-400'
                : 'text-slate-300'
            }`}
          />
        </button>
      ))}
    </div>
  );
}

export function StarRatingDisplay({ rating, reviewCount, size = 'sm' }) {
  return (
    <div className="flex items-center gap-2">
      <StarRating rating={Math.round(rating)} readonly size={size} />
      <span className="text-sm text-slate-600">
        {rating > 0 ? rating.toFixed(1) : 'N/A'}
        {reviewCount > 0 && ` (${reviewCount})`}
      </span>
    </div>
  );
}
